import { useLanguage } from "@/contexts/LanguageContext";

const Kopvillkor = () => {
  const { content } = useLanguage();

  return (
    <main className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-16">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-center">
            Köpvillkor
          </h1>
          
          <div className="prose prose-lg mx-auto text-foreground">
            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">1. Allmänna villkor</h2>
              <p className="mb-4">
                Dessa köpvillkor gäller för alla tjänster som tillhandahålls av Volym Studio ("Vi", "Oss", "Vårt"). 
                Genom att beställa våra tjänster accepterar du dessa villkor i sin helhet.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">2. Tjänster</h2>
              <p className="mb-4">
                Vi erbjuder professionell videoproduktion inkluderande reklamfilmer, videoavatarer, 
                explainer videos och animerade filmer. Alla tjänster levereras enligt överenskommen specifikation.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">3. Beställningsprocess</h2>
              <div className="mb-4">
                <h3 className="text-xl font-semibold mb-2">Acceptera & Beställ</h3>
                <p className="mb-4">
                  När du klickar på knappen "Acceptera & Beställ" i våra formulär förbinder sig ditt företag att köpa den 
                  specifika tjänsten enligt den angivna specifikationen och till det angivna priset. Produktionen påbörjas 
                  omedelbart efter bekräftelse.
                </p>
                
                <h3 className="text-xl font-semibold mb-2">Få Offert</h3>
                <p className="mb-4">
                  När du klickar på "Få Offert" skickas en detaljerad offertsammanställning och kontrakt för digital 
                  signering till din angivna e-postadress. Ingen bindande beställning sker förrän kontraktet signerats digitalt.
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">4. Priser och betalning</h2>
              <p className="mb-4">
                Alla priser anges inklusive moms där så är tillämpligt. Betalning sker enligt överenskommen betalplan, 
                normalt 50% vid projektstart och 50% vid leverans.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">5. Leverans och genomförande</h2>
              <p className="mb-4">
                Leveranstider är uppskattade och kan variera beroende på projektets komplexitet. Vi strävar efter att 
                hålla överenskomna leveransdatum och kommer att meddela eventuella förseningar i god tid.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">6. Ändringar och revideringar</h2>
              <p className="mb-4">
                Mindre ändringar ingår i våra paket enligt specifikation. Större ändringar som avviker från ursprunglig 
                beställning kan medföra tillkommande kostnader som kommuniceras innan genomförande.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">7. Immateriella rättigheter</h2>
              <p className="mb-4">
                När full betalning erhållits övergår användningsrättigheterna för det färdiga materialet till kunden. 
                Vi förbehåller oss rätten att använda projektet i marknadsföringssyfte om inget annat överenskommits.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">8. Ansvarsbegränsning</h2>
              <p className="mb-4">
                Vårt ansvar är begränsat till det direkta värdet av den beställda tjänsten. Vi ansvarar inte för 
                indirekta skador eller förlorad vinst till följd av våra tjänster.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">9. Ångerrätt</h2>
              <p className="mb-4">
                För företagskunder gäller inte konsumentköplagen. Ångerrätt gäller endast om produktionen inte påbörjats 
                och inom 24 timmar efter beställning.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">10. Force majeure</h2>
              <p className="mb-4">
                Vi ansvarar inte för förseningar eller utebliven leverans som beror på omständigheter utanför vår kontroll, 
                såsom naturkatastrofer, krig, pandemi eller myndighetsbeslut.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">11. Tvister</h2>
              <p className="mb-4">
                Eventuella tvister ska i första hand lösas genom förhandling. Uppstår tvist som inte kan lösas genom 
                förhandling ska den avgöras av svensk domstol med tillämpning av svensk rätt.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold mb-4">12. Kontaktinformation</h2>
              <p className="mb-4">
                <strong>Volym Studio</strong><br />
                E-post: info@volymkommunikation.se<br />
                Telefon: +46 10 750 28 66
              </p>
            </section>

            <div className="bg-muted p-6 rounded-lg mt-8">
              <p className="text-sm text-muted-foreground">
                Dessa köpvillkor uppdaterades senast: {new Date().toLocaleDateString('sv-SE')}
              </p>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Kopvillkor;